<style lang="less">
	@import "../assets/css/agent.less";
</style>
<template>
	<div class="agent">
		<div class="w1100">
			<div class="article">
				<div class="first inner">
					<div class="clearfix">
						<div class="img">
							<img src="../assets/img/u168.png" />
						</div>
						<div class="text">
							<h4><span>01</span>捷宇科技高拍仪K5A3TUZ</h4>
							<p>支持Windows 2000/XP/7/Vista/win8操作系统</p>
							<p>支持JGP、BMP、PNG、PDF、TIFF等格式可选</p>
							<p>支持证件双面拍摄后合并为一张图像</p>
							<p>可拍摄彩色、黑白、灰度图片</p>
							<p>支持照片预览设置：不预览、1/4预览</p>
							<p>拍摄幅面可设置：A4、A5、身份证、自动寻边、鼠标框选等</p>
							<p>具备专业OCR(文字识别）功能，可一键生成word、excel、txt文档</p>
							<p>可一键生成PDF；支持生成多面PDF；可检索PDF（附PDF制作工具）</p>
						</div>
					</div>
					<div class="imgs clearfix">
						<img src="../assets/img/u177.png" />
					</div>
					<!-- <div class="details">
						<swiper :options="banner_first">
							<swiper-slide>
								<img src="../assets/img/u175.png" />
							</swiper-slide>
							<swiper-slide>
								<img src="../assets/img/u176.png" />
							</swiper-slide>
							<div class="prev"></div>
							<div class="next"></div>
						</swiper>
					</div> -->
				</div>
				<div class="second inner">
					<div class="clearfix">
						<div class="img">
							<img src="../assets/img/u168.png" />
						</div>
						<div class="text">
							<h4><span>02</span>良田高拍仪WW680R</h4>
							<p>主摄像头500万像素，可配置1-2个辅摄像头（200万像素）</p>
							<p>带360°广角透镜的1W大功率LED补光灯</p>
							<p>集成A4、A3幅面可调的硬质文稿台</p>
							<p>全新产品外观结构设计，八合一集成功能</p>
							<p>可选择性调教方式</p>
							<p>超强OCR文字识别功能</p>
						</div>
					</div>

					<div class="imgs">
						<img src="../assets/img/u172.jpg" />
					</div>
				</div>
				<div class="third inner">
					<div class="clearfix">
						<div class="img">
							<img src="../assets/img/u210.png" />
						</div>
						<div class="text">
							<h4><span>03</span>雄帝电子证件阅读器EMP5900A</h4>
							<p>多种证件识读及成像能力</p>
							<p>光路处理技术 </p>
							<p>证件自动监测 </p>
							<p>射频识别 </p>
							<p>紫外成像 </p>
						</div>
					</div>

					<div class="imgs clearfix" style="padding: 0 100px;">
						<img style="width: 40%; float: left; margin-right: 40px;" src="../assets/img/u222_01.jpg" />
						<img style="width: 40%; float: left; margin-right: 40px;padding-top: 32px; height: 266px;" src="../assets/img/u222_02.jpg" />
						<br/>
						<img style="width: 90%; float: left; margin-top:20px;margin-right: 40px;" src="../assets/img/param_xiongdi.png" />
					</div>


				</div>
				<div class="fourth inner clearfix">
					<div class="clearfix">
						<div class="img">
							<img src="../assets/img/u189.jpg" />
						</div>
						<div class="text">
							<h4><span>04</span>神思身份证阅读器SS628(100M)</h4>
							<p>该终端具有阅读（验证）第二代居民身份证和采集指纹的功能。将第二代居民身份证至于终端感应区，与之相连的计算机可即时显示该证件持有人的彩色照片、文字信息及指纹信息；现场采集指纹信息并上传；再默认设置下，读出的信息可自动存档于计算机的数据库中，以备查询。</p>
						</div>
					</div>
					<div class="imgs">
						<img src="../assets/img/u11.png" />
						<!-- <img src="../assets/img/u192.png" />
						<img src="../assets/img/u193.png" /> -->
					</div>
					<!-- <div class="details">
						<swiper :options="banner_fourth">
							<swiper-slide>
								<img src="../assets/img/u191.png" />
							</swiper-slide>
							<swiper-slide>
								<img src="../assets/img/u192.png" />
							</swiper-slide>
							<swiper-slide>
								<img src="../assets/img/u193.png" />
							</swiper-slide>
							<div class="prev"></div>
							<div class="next"></div>
						</swiper>
					</div>			 -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import { swiper, swiperSlide } from 'vue-awesome-swiper'
	export default {
		name: "agent",
		data() {
			return {
				// banner_first: {
				// 	loop:true,  //是否循环
				// 	autoplay : false,
				// 	effect:'fade',
				// 	setWrapperSize :true,
				// 	navigation: {
				// 	  nextEl: '.next',
				// 	  prevEl: '.prev',
				// 	}
				// },
				// banner_fourth:{
				// 	loop:true,  //是否循环
				// 	autoplay : false,
				// 	effect:'fade',
				// 	setWrapperSize :true,
				// 	navigation: {
				// 	  nextEl: '.next',
				// 	  prevEl: '.prev',
				// 	}
				// }
			};
		},
		// components: {
		// 	swiper,
		// 	swiperSlide
		// },
		created() {

		},
		methods:{

		}
	}
</script>



// WEBPACK FOOTER //
// src/components/agent.vue